export const config = {
  stats: false,
  version: 2.31,
  imageBucketURL: "https://s3.us-east-2.amazonaws.com/366images/",
  apiBase: "https://optiqalapis.com:1357/catsearchapp",
  homeImg: "Cat Search App.png",
  appName: "Cat Search App",
};
